export const ASSET_MODAL_OPEN = "ASSET_MODAL_OPEN";
export const ASSET_MODAL_CLOSE = "ASSET_MODAL_CLOSE";

export const closeAssetModal = () => (dispatch) =>
  dispatch({
    type: ASSET_MODAL_CLOSE,
  });

export const openAssetModal = () => (dispatch) =>
  dispatch({
    type: ASSET_MODAL_OPEN,
  });
